import { BrowserRouter } from "react-router-dom";
import ApplicationRoutes from "./routes";
import MainProvider from "@/providers/AppProvider";
import ModalsRenderer from "@/components/modals/ModalsRenderer";
import ModalProvider from "@/providers/ModalsProvider";
import { TopLevelHooks } from "./hooks/topLevelHooks";
import useAuthentication from "./hooks/useAuthentication";
import { PageSpinner } from "@/ui/Spinner";

function App() {
  return (
    <ModalProvider>
      <MainProvider>
        <BrowserRouter>
          <ModalsRenderer />
          <TopLevelHooks />
          <AppLoader>
            <ApplicationRoutes />
          </AppLoader>
        </BrowserRouter>
      </MainProvider>
    </ModalProvider>
  );
}

function AppLoader({ children }: { children: React.ReactNode }) {
  const { loading } = useAuthentication();

  if (loading) return <PageSpinner />;
  return children;
}

export default App;
